import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/logo-ael.png'
import _imports_1 from '../assets/img/Warning.png'
import _imports_2 from '../assets/img/Documento icon.svg'
import _imports_3 from '../assets/img/Banco icon.svg'
import _imports_4 from '../assets/img/vendor/avalPay/LogoAvalPay.png'
import _imports_5 from '../assets/img/vendor/avalPay/LogoPayline.png'
import _imports_6 from '../assets/img/Chat.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-707de444"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pl-payment-form" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-ael" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo-ael-img",
    alt: "Logo Aportes En Línea",
    src: _imports_0,
    height: "30",
    width: "80"
  })
], -1))
const _hoisted_3 = { class: "pl-payment-form__card" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  width: "100",
  height: "100",
  alt: "warning"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popUpDD" }, [
  /*#__PURE__*/_createElementVNode("p", null, " Hemos identificado inconsistencias en tu información de pago. En breve, un agente se comunicará contigo para validar y actualizar tus datos. ")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  width: "100",
  height: "100",
  alt: "warning"
}, null, -1))
const _hoisted_7 = { class: "popUpDD" }
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "clic aquí", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  width: "100",
  height: "100",
  alt: "warning"
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popUpDD" }, [
  /*#__PURE__*/_createElementVNode("p", null, " Lamentamos informarte que tu pago ha expirado y no pudo completarse. Queremos asegurarnos de que puedas finalizar tu compra sin inconvenientes. Por favor intenta realizar tu pago nuevamente. ")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pl-payment-form__header" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "pl-payment-form__title" }, "Confirma tu pago"),
  /*#__PURE__*/_createElementVNode("p", { class: "pl-payment-form__subtitle" }, [
    /*#__PURE__*/_createTextVNode(" Selecciona el banco con el cual deseas realizar el pago. Al dar clic en "),
    /*#__PURE__*/_createElementVNode("b", null, "Pagar"),
    /*#__PURE__*/_createTextVNode(", podrás ingresar la información de pago que se mostrará en tu factura electrónica. ")
  ])
], -1))
const _hoisted_14 = { class: "pl-payment-form__summary-row" }
const _hoisted_15 = { class: "pl-payment-form__summary-item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "pl-payment-form__summary-icon",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "Documento",
    class: "pl-payment-form__summary-icon-image"
  })
], -1))
const _hoisted_17 = { class: "pl-payment-form__summary-pl" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Plan seleccionado", -1))
const _hoisted_19 = { class: "pl-payment-form__summary-total" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Total a pagar", -1))
const _hoisted_21 = { class: "pl-payment-form__method" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Método de pago", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "__avalpay" }, "Selecciona tu banco", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "pl-payment-form__select-prefix",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: "Banco",
    class: "pl-payment-form__select-prefix-image"
  })
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pl-payment-form__avalpay" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "pl-payment-form__avalpay-badge" }, [
    /*#__PURE__*/_createElementVNode("img", {
      alt: "Logo AvalPay",
      src: _imports_4
    })
  ]),
  /*#__PURE__*/_createElementVNode("p", null, " El pago se efectuará realizando el débito desde tu cuenta corriente, ahorros o de depósitos electrónicos a través de AvalPay Center. ")
], -1))
const _hoisted_26 = { class: "pl-payment-form__actions" }
const _hoisted_27 = { class: "pl-payment-form__pay-column" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pl-payment-form__powered" }, [
  /*#__PURE__*/_createElementVNode("small", null, "Powered by"),
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Logo Payline",
    src: _imports_5,
    height: "18",
    width: "54"
  })
], -1))
const _hoisted_29 = { class: "pl-payment-form__support" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "pl-payment-form__support-icon",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_6,
    alt: "Chat",
    class: "pl-payment-form__support-icon-image"
  })
], -1))
const _hoisted_31 = { class: "pl-payment-form__support-pl" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "¿Necesitas ayuda?", -1))
const _hoisted_33 = { class: "pl-payment-form__support-line" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Contáctanos en", -1))
const _hoisted_35 = ["href"]
const _hoisted_36 = {
  key: 1,
  class: "pl-payment-form__wait"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RedirectToKhuski = _resolveComponent("RedirectToKhuski")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ValidacionRechazada = _resolveComponent("ValidacionRechazada")!
  const _component_ErrorValidacion = _resolveComponent("ErrorValidacion")!
  const _component_ValidacionExpirada = _resolveComponent("ValidacionExpirada")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_validador_franja_horaria = _resolveComponent("validador-franja-horaria")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.processPayment)
      ? (_openBlock(), _createBlock(_component_el_form, {
          key: 0,
          ref: "formRef",
          model: _ctx.datosPago,
          rules: _ctx.rules,
          class: "pl-payment-form__form"
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              (_ctx.errorPayment)
                ? (_openBlock(), _createBlock(_component_RedirectToKhuski, {
                    key: 0,
                    valuePlan: _ctx.valuePlan,
                    documentsCount: _ctx.documentsCount
                  }, null, 8, ["valuePlan", "documentsCount"]))
                : _createCommentVNode("", true),
              _createVNode(_component_ValidacionRechazada, {
                visible: _ctx.validacionRechazada,
                modal: "",
                closable: false,
                header: "Error",
                draggable: false,
                id: "p-dialog"
              }, {
                footer: _withCtx(() => [
                  _createVNode(_component_Button, {
                    icon: "pi pi-times",
                    "on:clio": "",
                    onClick: _ctx.cerrarValidacionRechazada,
                    text: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Confirmar")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_row, {
                    gutter: 24,
                    justify: "space-evenly"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, {
                        xs: 4,
                        sm: 4,
                        md: 4,
                        lg: 4,
                        xl: 4
                      }, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, {
                        xs: 20,
                        sm: 20,
                        md: 20,
                        lg: 20,
                        xl: 20
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["visible"]),
              _createVNode(_component_ErrorValidacion, {
                visible: _ctx.errorValidacion,
                modal: "",
                closable: false,
                header: "Error",
                draggable: false,
                id: "p-dialog"
              }, {
                footer: _withCtx(() => [
                  _createVNode(_component_Button, {
                    icon: "pi pi-times",
                    onClick: _ctx.cerrarErrorValidacion,
                    text: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Confirmar")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_row, {
                    gutter: 24,
                    justify: "space-evenly"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, {
                        xs: 4,
                        sm: 4,
                        md: 4,
                        lg: 4,
                        xl: 4
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, {
                        xs: 20,
                        sm: 20,
                        md: 20,
                        lg: 20,
                        xl: 20
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("p", null, [
                              _createTextVNode(" Haz "),
                              _createElementVNode("a", { href: _ctx.urlChatSoporte }, _hoisted_10, 8, _hoisted_8),
                              _createTextVNode(" para contactar a nuestro equipo de soporte, quienes te ayudarán a completar tu gestión. ")
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["visible"]),
              _createVNode(_component_ValidacionExpirada, {
                visible: _ctx.validacionExpirada,
                modal: "",
                closable: false,
                header: "Error",
                draggable: false,
                id: "p-dialog"
              }, {
                footer: _withCtx(() => [
                  _createVNode(_component_Button, {
                    icon: "pi pi-times",
                    onClick: _ctx.cerrarValidacionExpirada,
                    text: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Confirmar")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_row, {
                    gutter: 24,
                    justify: "space-evenly"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, {
                        xs: 4,
                        sm: 4,
                        md: 4,
                        lg: 4,
                        xl: 4
                      }, {
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, {
                        xs: 20,
                        sm: 20,
                        md: 20,
                        lg: 20,
                        xl: 20
                      }, {
                        default: _withCtx(() => [
                          _hoisted_12
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["visible"]),
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("strong", null, _toDisplayString(_ctx.normalizeNumberValidator(_ctx.documentsCount)) + " documentos", 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("strong", null, _toDisplayString(_ctx.colombianCurrencyValidator(_ctx.valuePlan)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _hoisted_23,
                _createVNode(_component_el_form_item, {
                  class: "pl-payment-form__field",
                  prop: "banco"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.datosPago.banco,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.datosPago.banco) = $event)),
                      class: "pl-payment-form__select",
                      placeholder: " "
                    }, {
                      prefix: _withCtx(() => [
                        _hoisted_24
                      ]),
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bancos, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.codigo,
                            label: item.nombre,
                            value: item.nombre,
                            disabled: item.codigo == '0'
                          }, null, 8, ["label", "value", "disabled"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _hoisted_25,
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("button", {
                  class: "pl-payment-form__button pl-payment-form__button--secondary",
                  type: "button",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.comebackToPlans && _ctx.comebackToPlans(...args)))
                }, " Regresar "),
                _createVNode(_component_validador_franja_horaria, {
                  modelValue: _ctx.pagoRestringido,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pagoRestringido) = $event)),
                  horaInicio: _ctx.franjaPagoNoDisponible.horaInicio,
                  minutoInicio: _ctx.franjaPagoNoDisponible.minutoInicio,
                  horaFin: _ctx.franjaPagoNoDisponible.horaFin,
                  minutoFin: _ctx.franjaPagoNoDisponible.minutoFin,
                  intervalo: 1000
                }, null, 8, ["modelValue", "horaInicio", "minutoInicio", "horaFin", "minutoFin"]),
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_component_el_tooltip, {
                    content: _ctx.mensajePagoNoDisponible,
                    placement: "right",
                    "open-delay": "0",
                    disabled: !_ctx.pagoRestringido
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.validarDatosParaPago && _ctx.validarDatosParaPago(...args))),
                        class: _normalizeClass(
                  _ctx.pagoRestringido
                    ? 'pl-payment-form__button pl-payment-form__button--secondary'
                    : 'pl-payment-form__button pl-payment-form__button--primary'
                )
                      }, " Pagar ", 2)
                    ]),
                    _: 1
                  }, 8, ["content", "disabled"]),
                  _hoisted_28
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _createElementVNode("div", _hoisted_31, [
                  _hoisted_32,
                  _createElementVNode("div", _hoisted_33, [
                    _hoisted_34,
                    _createElementVNode("a", {
                      class: "pl-payment-form__support-brand",
                      href: _ctx.urlChatSoporte,
                      target: "_blank",
                      rel: "noopener noreferrer"
                    }, "Aportes en Línea", 8, _hoisted_35)
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"]))
      : (_openBlock(), _createElementBlock("h1", _hoisted_36, "Espera un momento...")),
    (_ctx.processPayment)
      ? (_openBlock(), _createBlock(_component_Spinner, {
          key: 2,
          type: "modern"
        }))
      : _createCommentVNode("", true)
  ]))
}